import { useMemo } from 'react'

import { getConversationActorRole } from '@app/helpers'
import { isB2BView } from '@app/utils'

import { useConversation } from './useConversation'
import { useUser } from '../user/useUser'

export const useConversationActorRole = () => {
  const conversation = useConversation()
  const { currentUser } = useUser()

  const isB2B = isB2BView()

  return useMemo(
    () =>
      getConversationActorRole(
        conversation?.participants,
        currentUser?.id,
        isB2B
      ),
    [conversation?.participants, currentUser?.id, isB2B]
  )
}
